import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Typography } from '@utex/ui-kit';
import { TabProps } from '../../../types';

export interface Props {
  isActive: boolean;
  onClick: () => void;
}

export const RUBTab: React.FC<TabProps> = (props) => {
  const { t } = useTranslation('byCard');

  return (
    <Tabs.Item
      {...props}
      title={t('In rubles')}
      caption={
        <Typography.Text size={{ tablesktop: 'M', phonablet: 'XS' }}>
          {t('MIR, Visa, MasterCard')}
        </Typography.Text>
      }
    >
      {t('In rubles')}
    </Tabs.Item>
  );
};
